// services/unitsApi.ts
import apiClient from "./apiClient";

export interface Unit {
  id: number;
  name: string;
  symbol: string;
  organizationId: number;
  status: "active" | "inactive";
  createdAt: string;
  updatedAt: string;
}

export interface UnitsResponse {
  units: Unit[];
  pagination: {
    totalItems: number;
    totalPages: number;
    currentPage: number;
    itemsPerPage: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  };
}

export const unitsApi = {
  getAll: async (
    page: number,
    limit: number,
    search: string,
  ): Promise<UnitsResponse> => {
    const response = await apiClient.get("/units", {
      params: { page, limit, search: search.trim() || undefined },
    });
    return response.data;
  },
  create: async (data: {
    name: string;
    symbol: string;
  }): Promise<{ message: string; unit: Unit }> => {
    const response = await apiClient.post("/units", data);
    return response.data;
  },
  update: async (
    id: number,
    data: { name?: string; symbol?: string; status?: "active" | "inactive" },
  ): Promise<{ message: string; unit: Unit }> => {
    const response = await apiClient.put(`/units/${id}`, data);
    return response.data;
  },
  delete: async (id: number): Promise<{ message: string }> => {
    const response = await apiClient.delete(`/units/${id}`);
    return response.data;
  },
};
